var render = function render(){var _vm=this,_c=_vm._self._c;return (!_vm.maintenance)?_c('div',{staticClass:"wrapper"},[(_vm.showBrowserIncompatibilityBanner)?_c('BrowserIncompatibilityBanner'):_vm._e(),_c('CHeader'),_c('CMain')],1):_c('Maintenance')
}
var staticRenderFns = []

export { render, staticRenderFns }